import React from "react";

const MOBILE_NUMBER_EMAIL = React.lazy(() => import("./signup"));
const RESUME = React.lazy(() => import("./upload-resume"));
const WORK_AUTH = React.lazy(() => import("./authorization"));
const CURRENT_LOCATION = React.lazy(() => import("./current-location"));
const CURRENT_DESIGNATION_CURRENT_COMPANY = React.lazy(
  () => import("./designation-and-company"),
);
const TRIUMPH_FIELDS = React.lazy(() => import("./disability"));
const EDUCATION_TYPE = React.lazy(() => import("./education-type"));
const START_DATE_CURRENTLY_WORKING_HERE_CHECKBOX = React.lazy(
  () => import("./employment-start"),
);
const END_DATE = React.lazy(() => import("./employment-end"));
const FULL_NAME = React.lazy(() => import("./full-name"));
const SPECIALISATION = React.lazy(() => import("./specialization"));
const TOTAL_EXPERIENCE = React.lazy(() => import("./total-exp"));
const UNIVERSITY = React.lazy(() => import("./university"));
const SHOW_JR = React.lazy(() => import("./jobs"));
const SHOW_JR_TWICE = React.lazy(() => import("./jobs"));
const LINKEDIN = React.lazy(() => import("./linkedin"));
const WHAT_ARE_YOU_LOOKING_FOR_CHECKBOX = React.lazy(
  () => import("./looking-for"),
);
const NATIONALITY = React.lazy(() => import("./nationality"));
const NOTICE_PERIOD = React.lazy(() => import("./notice-period"));
const PREFERRED_LOCATION = React.lazy(() => import("./preferred-location"));
const PREFERRED_JOB_TITLE = React.lazy(() => import("./preferred-role"));
const HIGHEST_QUALIFICATION = React.lazy(() => import("./qualification"));
const CURRENT_SALARY_HIDE_SALARY_CHECKBOX = React.lazy(
  () => import("./salary-range"),
);
const SKILLS = React.lazy(() => import("./skills"));
const GENDER = React.lazy(() => import("./gender"));
const YEAR_OF_GRADUATION = React.lazy(() => import("./graduation-year"));
const QUALIFICATION_BOARD = React.lazy(() => import("./board"));
const QUALIFICATION_MEDIUM = React.lazy(() => import("./medium"));
const SUCCESS = React.lazy(() => import("./success"));
const LAST_WORKING_DAY = React.lazy(() => import("./last-working-day"));
const MOBILE_OTP = React.lazy(
  () => import("./verification/mobile-verification"),
);
const EMAIL_OTP = React.lazy(() => import("./verification/email-verification"));
const INDUSTRY = React.lazy(() => import("./industry"));

export const regMap: { [key: string]: React.ComponentType } = {
  MOBILE_NUMBER_EMAIL, //0
  MOBILE_OTP, //1
  EMAIL_OTP, //2
  RESUME, //3
  LINKEDIN, //4
  FULL_NAME, //5
  TOTAL_EXPERIENCE, //6
  CURRENT_LOCATION, //7
  NATIONALITY, //8
  WORK_AUTH, //9
  CURRENT_DESIGNATION_CURRENT_COMPANY, //10
  SHOW_JR, //11
  START_DATE_CURRENTLY_WORKING_HERE_CHECKBOX, //12
  END_DATE, //13
  SKILLS, //14
  CURRENT_SALARY_HIDE_SALARY_CHECKBOX, //15
  NOTICE_PERIOD, //16
  LAST_WORKING_DAY, //17
  GENDER, //18
  TRIUMPH_FIELDS, //19
  HIGHEST_QUALIFICATION, //20
  QUALIFICATION_MEDIUM, //21
  QUALIFICATION_BOARD, //22
  YEAR_OF_GRADUATION, //23
  SPECIALISATION, //24
  UNIVERSITY, //25
  EDUCATION_TYPE, //26
  PREFERRED_JOB_TITLE, //27
  PREFERRED_LOCATION, //28
  WHAT_ARE_YOU_LOOKING_FOR_CHECKBOX, //29
  SUCCESS, //30
  SHOW_JR_TWICE, //31
  INDUSTRY, //32
};
